import React from 'react'

const LessonsSection = () => {
  return (
    <div>
      lesons
    </div>
  )
}

export default LessonsSection
